export const SYNC_REPLAY_ERROR_CODES = {
  COUPON_NOT_FOUND: "COUPON_NOT_FOUND",
  COUPON_USAGE_LIMIT_EXCEEDED: "COUPON_USAGE_LIMIT_EXCEEDED",
  COUPON_REPLAY_FAILED: "COUPON_REPLAY_FAILED",
  CUSTOMER_SNAPSHOT_INVALID: "CUSTOMER_SNAPSHOT_INVALID",
  REWARD_NOT_FOUND: "REWARD_NOT_FOUND",
  REWARD_REPLAY_FAILED: "REWARD_REPLAY_FAILED",
  REWARD_INSUFFICIENT_POINTS: "REWARD_INSUFFICIENT_POINTS",
} as const;

export type SyncReplayErrorCode =
  (typeof SYNC_REPLAY_ERROR_CODES)[keyof typeof SYNC_REPLAY_ERROR_CODES];

export class SyncReplayError extends Error {
  readonly code: SyncReplayErrorCode;

  constructor(code: SyncReplayErrorCode, message: string) {
    super(message);
    this.name = code;
    this.code = code;
  }
}

export function isCouponReplayErrorCode(
  errorCode: string | null | undefined,
): boolean {
  if (!errorCode) return false;
  return (
    errorCode === SYNC_REPLAY_ERROR_CODES.COUPON_NOT_FOUND ||
    errorCode === SYNC_REPLAY_ERROR_CODES.COUPON_USAGE_LIMIT_EXCEEDED ||
    errorCode === SYNC_REPLAY_ERROR_CODES.COUPON_REPLAY_FAILED
  );
}

export function isRewardReplayErrorCode(
  errorCode: string | null | undefined,
): boolean {
  if (!errorCode) return false;
  return (
    errorCode === SYNC_REPLAY_ERROR_CODES.REWARD_NOT_FOUND ||
    errorCode === SYNC_REPLAY_ERROR_CODES.REWARD_REPLAY_FAILED ||
    errorCode === SYNC_REPLAY_ERROR_CODES.REWARD_INSUFFICIENT_POINTS
  );
}

export function isPricingReplayErrorCode(
  errorCode: string | null | undefined,
): boolean {
  return isCouponReplayErrorCode(errorCode) || isRewardReplayErrorCode(errorCode);
}
